// extracted by mini-css-extract-plugin
export default {"platform":"o6OgC","platform--non-icon":"fWx7F","platform--active":"lZuMg","platform__icon":"YUrV4"};